import { trackEvent } from "./index";

export const trackServiceCreateInit = () => {
    trackEvent("service_create_init", {
    });
};